export default __webpack_public_path__ + "static/myanmar-b85c919c069fdf4d3fcf82e62648de92.jpg";